// src/api/consts/dreamina.ts

export const BASE_URL_DREAMINA_US = "https://dreamina-api.us.capcut.com";
export const BASE_URL_IMAGEX_US = "https://imagex16-normal-us-ttp.capcutapi.us";

export const BASE_URL_DREAMINA_HK = "https://mweb-api-sg.capcut.com";
export const BASE_URL_IMAGEX_HK = "https://imagex-normal-sg.capcutapi.com";


export const WEB_VERSION = "7.5.0";
export const DA_VERSION = "3.3.12";
export const AIGC_FEATURES = "app_lip_sync";
